import axios from "../utils/axios";

//upload
export const postUpdateTaskDatesFromExcel = (payload) => {
    return axios.post(`/PlannedMaintenance/UpdateTaskDatesFromExcel`, payload);
};

//download
export const postExportTasksForUpdateDate = (filter) => {
    return axios.post(`/PlannedMaintenance/ExportTasksForUpdateDate`, filter, {
        responseType: "blob",
    });
};

//exceltolist
export const postDateExcelToList = (payload) => {
    return axios.post(`/PlannedMaintenance/DateExcelToList`, payload);
};
